module.exports = "<img  [src]=\"source\" class=\"barBg\"/>"